import React from 'react';
import { Pressable } from 'react-native';
import { Text } from 'tamagui';
import { colors } from '../theme/colors';

interface ChipProps {
  selected?: boolean | undefined;
  onPress: () => void;
  children: React.ReactNode;
  /** Accent color used when selected. Defaults to accentCerulean. */
  color?: string | undefined;
}

/** Toggle chip for travel style, interests, etc. */
export function Chip({ selected, onPress, children, color = colors.accentCerulean }: ChipProps) {
  return (
    <Pressable
      onPress={onPress}
      style={{
        paddingHorizontal: 14,
        paddingVertical: 8,
        borderRadius: 20,
        borderWidth: 1,
        backgroundColor: selected ? color : 'transparent',
        borderColor: selected ? color : colors.borderDefault,
        minHeight: 36,
        alignItems: 'center',
        justifyContent: 'center',
      }}
    >
      <Text
        fontSize={13}
        fontWeight="600"
        color={selected ? colors.textOnDark : colors.textSubdued}
      >
        {children}
      </Text>
    </Pressable>
  );
}
